(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('load-more-pages')) {
    customElements.define('load-more-pages', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        this.section = this.closest('.shopify-section');
        this.selector = 'ul.product-grid, .blog-articles, .collection-list';
        this.grid = this.section?.querySelector(this.selector);
        this.link = this.querySelector('[data-load-more]');
        if (!this.grid || !this.link) return;
        this.querySelector('nav').hidden = true;
        this.link.hidden = false;
        this.onclick = (event) => this.load(event);
      }
      disconnectedCallback() {
        this.request?.abort();
      }
      async load(event) {
        if (!event.target.closest('[data-load-more]') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (this.getAttribute('aria-busy') === 'true') return;
        const url = this.link.href;
        this.setAttribute('aria-busy', 'true');
        this.link.setAttribute('aria-disabled', 'true');
        this.request = new AbortController();
        try {
          const response = await fetch(url, { signal: this.request.signal });
          if (!response.ok) throw new Error();
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = page.getElementById(this.section.id);
          const grid = section?.querySelector(this.selector);
          const pagination = section?.querySelector('load-more-pages');
          if (!grid || !grid.children.length) throw new Error();
          if (!this.isConnected) return;
          const first = grid.firstElementChild;
          this.grid.append(...grid.children);
          first.querySelector('a')?.focus({ preventScroll: true });
          if (pagination?.querySelector('[data-load-more]')) this.replaceWith(pagination);
          else this.remove();
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) window.location.assign(url);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
